import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { baseSocialeSociSpecialiRules } from './base-sociale-soci-speciali.rules';
import { baseSocialeStoricoRules } from './base-sociale-storico.rules';
import { baseSocialeComposizioneSociRules } from './base-sociale-composizione-soci.rules';
import { baseSocialeEserciziPrecedentiRules } from './base-sociale-esercizi-precedenti.rules';
import { baseSocialeOccupazioneRules } from './base-sociale-occupazione.rules';
import { baseSocialeRegolamentoRules } from './base-sociale-regolamento.rules';
import { baseSocialeRapportiLavoroRules } from './base-sociale-rapporti-lavoro.rules';
import { baseSocialeContrattiRules } from './base-sociale-contratti.rules';
import { baseSocialeAttivitaRules } from './base-sociale-attivita.rules';

export const baseSocialeRules: FormGroupRules = {
    ...baseSocialeSociSpecialiRules,
    ...baseSocialeStoricoRules,
    ...baseSocialeComposizioneSociRules,
    ...baseSocialeEserciziPrecedentiRules,
    ...baseSocialeOccupazioneRules,
    ...baseSocialeRegolamentoRules,
    ...baseSocialeRapportiLavoroRules,
    ...baseSocialeContrattiRules,
    ...baseSocialeAttivitaRules,
};

export const baseSocialeFormValidators = Object.values(baseSocialeRules);
